import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  authenticated: boolean | undefined;
  user: any | null;
}

const initialState: AuthState = {
  authenticated: undefined,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated: (state, action: PayloadAction<{ user: any }>) => {
      state.authenticated = true;
      state.user = action.payload.user;
    },
    logout: (state) => {
      state.authenticated = false;
      state.user = null;
    },
    setLoading: (state) => {
      state.authenticated = undefined;
    },
  },
});

export const { setAuthenticated, logout, setLoading } = authSlice.actions;
export default authSlice.reducer;
